export default __webpack_public_path__ + "static/media/Great Cloak of Blessed Winds.e292ffa8.jpg";